import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomCardList from "../components/Cards";
import PageLoader from "../components/Loader";
import Title from "../components/PageTitle";
import CustomTable from "../components/Table";
import { useToast } from "../components/Toast";
import useIsMobile from "../Hooks/useIsMobile";
import apiService from "../Services/api.service";
const Activation = () => {
  const isMobile = useIsMobile();
  const Toast = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const [kiosk, setKiosk] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredDoctors, setFilteredDoctors] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const auth = localStorage.getItem("token");
  useEffect(() => {
    getKiosk(page, rowsPerPage);
  }, [page, rowsPerPage]);

  const getKiosk = async (page, limit) => {
    setIsLoading(true);
    try {
      const { mappedDoctors, count } = await apiService.fetchKiosk(
        auth,
        page,
        limit
      );
      setKiosk(mappedDoctors);
      setFilteredDoctors(mappedDoctors);
      setTotalCount(count);
      
    } catch (error) {
      Toast.error("Error while Fetching");
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage + 1);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  useEffect(() => {
    if (typingTimeout) clearTimeout(typingTimeout);

    const timeout = setTimeout(async () => {
      try {
        const { mappedDoctors, count } = await apiService.fetchKiosk(
          auth,
          page,
          10,
          searchQuery
        );
        setTotalCount(count);
        setFilteredDoctors(mappedDoctors);
      } catch (error) {
        console.error("Error fetching Doctors:", error);
        Toast.error("Error while Fetching");
      }
    }, 500); // 500ms debounce

    setTypingTimeout(timeout);

    // Cleanup
    return () => clearTimeout(timeout);
  }, [searchQuery, page]);

  const handleSearch = (event) => {
    const keyword = event.target.value.toLowerCase();
    setSearchQuery(keyword); // Only set the query
  };

  const handleStatusChange = async (event, row) => {
    const newStatus = event.target.value;
    const kioskId = row.id;

    try {
      setIsLoading(true);
      await apiService.updateActivation({
        kioskId,
        activationStatus: newStatus,
        token: auth,
      });
      setFilteredDoctors((prevData) =>
        prevData.map((item) =>
          item.id === kioskId ? { ...item, status: newStatus } : item
        )
      );
      Toast.success("Activation status updated");
    } catch (error) {
      let errorMessage = "Something went wrong..!";

      if (error.response && error.response.data) {
        if (typeof error.response.data === "string") {
          // Extract text inside <pre>...</pre> and get only the first line
          const match = error.response.data.match(/<pre>(.*?)<\/pre>/s);
          if (match) {
            errorMessage = match[1].split("<br>")[0].trim(); // Get only the first line before <br>
          }
        } else if (error.response.data.message) {
          errorMessage = error.response.data.message;
        }
      }
      Toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const ActivationStatus = [
    "not activated",
    "temporary activated",
    "fully activated",
    "disabled",
  ];
  const formatDate = (dateString) => {
    if (dateString == "NA") return "NA";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };
  const columns = [
    {
      field: "clinicName",
      headerName: "Clinic Name",
      align: "center",
    },
    {
      field: "location",
      headerName: "Location",
      align: "center",
    },
    {
      field: "status",
      headerName: "Activation Status",
      align: "center",
      renderCell: (value, row) => (
        <Select
          value={value}
          onChange={(e) => handleStatusChange(e, row)}
          sx={{ minWidth: 200 }}
        >
          {ActivationStatus.map((status) => (
            <MenuItem key={status} value={status}>
              {status}
            </MenuItem>
          ))}
        </Select>
      ),
    },
    {
      field: "Activationvalidity",
      headerName: "Validity",
      align: "center",
      renderCell: (value) => formatDate(value), // Formatting the date
    },
  ];

  return (
    <div>
      <Paper sx={{ padding: 2 }}>
        <Title text="Activation" />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            marginBottom: 2,
          }}
        >
          <TextField
            label="Search"
            variant="outlined"
            value={searchQuery}
            onChange={handleSearch}
            fullWidth
            sx={{ marginBottom: 2, marginTop: 3 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
        {isMobile ? (
          <CustomCardList
            page={page - 1}
            rowsPerPage={rowsPerPage}
            totalCount={totalCount}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            fields={[
              { label: "Clinic Name", key: "clinicName" },
              { label: "Location", key: "location" },
            ]}
            data={filteredDoctors}
            DropdownLabel="Activation Status"
            dropdownField="status" // Show dropdown for "status"
            dropdownOptions={ActivationStatus} // Use same options as table
            onDropdownChange={handleStatusChange} // Handle status update
          />
        ) : (
          <CustomTable
            columns={columns}
            data={filteredDoctors}
            page={page - 1}
            rowsPerPage={rowsPerPage}
            totalCount={totalCount}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        )}
      </Paper>
      {isLoading && <PageLoader />}
    </div>
  );
};

export default Activation;
